import { generalAlertError } from '../../common/utils/alerts';
import axe from '../../services/axios-client/axiosClient';
import caller from './usefulDocumentsSlice';

export const getUsefulDocuments = async () => {
  caller.getDocumentsPending();
  try {
    const response = await axe.get(
      '/useful-documents',
    );

    if (response.status !== 200) {
      generalAlertError('Errore Interno');
      caller.getDocumentsRejected('Errore Interno');
      return;
    }

    caller.getDocumentsSuccess(response.data.data);
  } catch (err) {
    caller.getDocumentsRejected('Errore Interno');
    generalAlertError('Errore Interno');
  }
};
